"use client";
import {
  GroupLabelContext
} from "./3X3MDQGM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./5M6RSQEC.js";
import {
  useId,
  useSafeLayoutEffect
} from "./6O5OEQGF.js";
import {
  __spreadValues
} from "./4R3V3JGP.js";

// src/group/group-label.ts
import { useContext } from "react";
import { removeUndefinedValues } from "@ariakit/core/utils/misc";
var TagName = "div";
var useGroupLabel = createHook(
  function useGroupLabel2(props) {
    const setLabelId = useContext(GroupLabelContext);
    const id = useId(props.id);
    useSafeLayoutEffect(() => {
      setLabelId == null ? void 0 : setLabelId(id);
      return () => setLabelId == null ? void 0 : setLabelId(void 0);
    }, [setLabelId, id]);
    props = __spreadValues({
      id,
      "aria-hidden": true
    }, props);
    return removeUndefinedValues(props);
  }
);
var GroupLabel = forwardRef(function GroupLabel2(props) {
  const htmlProps = useGroupLabel(props);
  return createElement(TagName, htmlProps);
});

export {
  useGroupLabel,
  GroupLabel
};
